// extracted by css-extract-rspack-plugin
var _1 = "cj";
var _2 = "ts";
var _3 = "vw";
var _4 = "e3";
var _5 = "vt";
var _6 = "vu";
var _7 = "et";
var _8 = "ej";
var _9 = "vv";
var _a = "m9";
var _b = "fl";
export { _1 as "active", _2 as "big", _3 as "border", _4 as "favoriteLinkComponent", _5 as "heart", _6 as "heartBorder", _7 as "loading", _8 as "loadingComponent", _9 as "loadingEffect", _a as "loadingModal", _b as "text" }
